/**
 * Portal branding / contact settings from AppSettings (injected as window.__PORTAL_SETTINGS__).
 * Phase 8 Q-8-006: phones/emails are not hardcoded in UI — read here.
 */

export interface IPortalSettings {
    appPath: string;
    apiHostUrl: string;
    brandName: string;
    brandHomeUrl: string;
    customerServicePhone: string;
    callCenterPhone: string;
    licenseHelpPhone: string;
    supportEmail: string;
}

const DEFAULTS: IPortalSettings = {
    appPath: "",
    apiHostUrl: "https://localhost:44300/qualitasauto",
    brandName: "Qualitas",
    brandHomeUrl: "",
    // Contact values: only from appsettings via window.__PORTAL_SETTINGS__ (Q-8-006).
    customerServicePhone: "",
    callCenterPhone: "",
    licenseHelpPhone: "",
    supportEmail: ""
};

function readInjectedSettings(): Partial<IPortalSettings> {
    if (typeof window === "undefined") {
        return {};
    }
    return (window as any).__PORTAL_SETTINGS__ || {};
}

function normalizeAppPath(raw: string | undefined): string {
    if (!raw) {
        return "";
    }
    const withSlash = raw.startsWith("/") ? raw : "/" + raw;
    return withSlash.replace(/\/+$/, "");
}

function normalizeApiHostUrl(raw: string | undefined): string {
    if (!raw) {
        return "";
    }
    return raw.replace(/\/+$/, "");
}

export function getPortalSettings(): IPortalSettings {
    const injected = readInjectedSettings();
    return {
        appPath: normalizeAppPath(injected.appPath) || DEFAULTS.appPath,
        apiHostUrl: normalizeApiHostUrl(injected.apiHostUrl) || DEFAULTS.apiHostUrl,
        brandName: injected.brandName || DEFAULTS.brandName,
        brandHomeUrl: injected.brandHomeUrl != null ? injected.brandHomeUrl : DEFAULTS.brandHomeUrl,
        customerServicePhone: injected.customerServicePhone || DEFAULTS.customerServicePhone,
        callCenterPhone: injected.callCenterPhone || DEFAULTS.callCenterPhone,
        licenseHelpPhone: injected.licenseHelpPhone || DEFAULTS.licenseHelpPhone,
        supportEmail: injected.supportEmail || DEFAULTS.supportEmail
    };
}

export function phoneToTelHref(phone: string): string {
    const digits = (phone || "").replace(/[^\d]/g, "");
    return digits ? ("tel:" + digits) : "tel:";
}

export function mailtoHref(email: string): string {
    return email ? ("mailto:" + email) : "mailto:";
}
